;(function () {
  if (window.__WhackAPouchLoaded) return
  window.__WhackAPouchLoaded = true

  const init = () => {
    const root = document.querySelector("[data-whack-a-pouch]")
    if (!root) return

    const config = window.__WhackAPouchConfig || {}
    const PRODUCTS = config.products || []
    const DANGER_IMG = config.dangerImage || ""
    const GOLD_IMG = config.goldImage || ""

    /* ── Round config ── */
    const ROUNDS = [
      {
        secs: 30,
        spawn: [1200, 950, 780, 620],
        life: [2000, 1700, 1450, 1200],
        dPct: 0.09,
        goldCount: 1,
        title: "Round One Complete",
        msg: "Great start! Round 2 picks up the pace — keep those streaks going!",
        hint: "Hit 10 in a row to bank +3s for next round!",
        btnTxt: "Start round 2",
      },
      {
        secs: 30,
        spawn: [1050, 820, 640, 490],
        life: [1800, 1500, 1250, 1000],
        dPct: 0.12,
        goldCount: 2,
        title: "Round Two Complete",
        msg: "You're on fire! Final round is the hardest — stay sharp!",
        hint: "One more round — give it everything!",
        btnTxt: "Start round 3",
      },
      {
        secs: 30,
        spawn: [780, 590, 440, 320],
        life: [1450, 1200, 980, 760],
        dPct: 0.18,
        goldCount: 3,
        title: "All 3 rounds done!",
        msg: "",
        hint: "",
        btnTxt: "",
      },
    ]
    const TOTAL_ROUNDS = 3
    const NH = 9

    /* ── State ── */
    let currentRound = 0
    let roundScores = [0, 0, 0]
    let totalScore = 0
    let best = 0
    let roundScore = 0
    let roundHits = 0,
      roundMisses = 0
    let allHits = 0,
      allMisses = 0
    let streak = 0,
      bestStreak = 0
    let combo = 1,
      peakCombo = 1
    let running = false,
      timeLeft = 30
    let bankedBonus = 0,
      streakBonusTriggered = false
    let goldSpawned = 0
    let tickId = null,
      spawnId = null
    const holeState = Array(NH).fill(null)
    const canEls = []

    /* ── Build product list ── */
    const NORMAL_CANS = PRODUCTS.filter((p) => p.image)
    const DANGER_CAN = { type: "d", name: "DANGER", image: DANGER_IMG }
    const GOLD_CAN = { type: "g", name: "DOUBLE POINTS", image: GOLD_IMG }

    /* ── API endpoints ── */
    const API = {
      start: "/apps/games/whack-a-pouch/start",
      score: "/apps/games/whack-a-pouch/score",
      updateName: "/apps/games/whack-a-pouch/update-name",
      progress: "/apps/games/whack-a-pouch/round-progress",
      leaderboard: "/apps/games/whack-a-pouch/leaderboard",
      me: "/apps/games/whack-a-pouch/me",
    }

    const PROGRESS_KEY = "wap_in_progress_v1"

    let sessionToken = null
    let gameStartedAt = 0
    let playsRemaining = null
    let scoreSubmitted = false

    /* ── Local fallbacks (for when API is offline) ── */
    const LB_KEY = "wap_lb_v1"
    const BEST_KEY = "wap_best_v1"
    let cachedLeaderboard = null
    let myStats = null

    async function apiGetLeaderboard() {
      try {
        const res = await fetch(API.leaderboard, { credentials: "include" })
        if (!res.ok) throw new Error(res.status)
        const data = await res.json()
        cachedLeaderboard = data
        return data
      } catch (err) {
        console.warn("Whack-A-Pouch: leaderboard fetch failed, using local", err)
        return null
      }
    }

    async function apiGetMe() {
      try {
        const res = await fetch(API.me, { credentials: "include" })
        if (!res.ok) throw new Error(res.status)
        myStats = await res.json()
        return myStats
      } catch (err) {
        console.warn("Whack-A-Pouch: me fetch failed", err)
        return null
      }
    }

    async function apiStartGame() {
      try {
        const res = await fetch(API.start, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        })
        const data = await res.json().catch(() => null)
        if (!res.ok) {
          if (res.status === 403) {
            return { error: "no_plays", message: (data && data.message) || "No plays remaining this week" }
          }
          if (res.status === 401) {
            return { error: "not_logged_in" }
          }
          throw new Error(res.status)
        }
        sessionToken = data.sessionToken
        if (typeof data.remaining === "number") playsRemaining = data.remaining
        return data
      } catch (err) {
        console.warn("Whack-A-Pouch: start failed, using local", err)
        return null
      }
    }

    async function apiSubmitScore(payload) {
      try {
        const res = await fetch(API.score, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ ...payload, sessionToken }),
        })
        const data = (await res.json().catch(() => null)) || {}
        data._status = res.status
        if (!res.ok) {
          console.warn("Whack-A-Pouch: score submit failed", res.status, data)
          return data
        }
        if (typeof data.remaining === "number") playsRemaining = data.remaining
        return data
      } catch (err) {
        console.warn("Whack-A-Pouch: score submit error", err)
        return null
      }
    }

    async function apiSaveProgress(payload) {
      // Save to localStorage immediately as a fallback
      try {
        localStorage.setItem(
          PROGRESS_KEY,
          JSON.stringify({ ...payload, sessionToken, savedAt: Date.now() })
        )
      } catch (e) {}

      // Best-effort push to backend (silently fails if endpoint isn't deployed)
      try {
        await fetch(API.progress, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ ...payload, sessionToken }),
          keepalive: true,
        })
      } catch (err) {
        // Ignore — fallback is the localStorage save above
      }
    }

    function clearProgress() {
      try {
        localStorage.removeItem(PROGRESS_KEY)
      } catch (e) {}
    }

    async function apiUpdateName(displayName) {
      try {
        const res = await fetch(API.updateName, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ sessionToken, displayName }),
        })
        const data = (await res.json().catch(() => null)) || {}
        data._status = res.status
        if (!res.ok) {
          console.warn("Whack-A-Pouch: name update failed", res.status, data)
          return data
        }
        return data
      } catch (err) {
        console.warn("Whack-A-Pouch: name update error", err)
        return null
      }
    }

    function getLocalLeaderboard() {
      try {
        return JSON.parse(localStorage.getItem(LB_KEY) || "[]")
      } catch (e) {
        return []
      }
    }

    function saveLocalLeaderboard(data) {
      try {
        localStorage.setItem(LB_KEY, JSON.stringify(data))
      } catch (e) {}
    }

    // Seed local leaderboard if empty (fallback only)
    if (!getLocalLeaderboard().length) {
      saveLocalLeaderboard([
        { n: "Jamie K.", p: 8640 },
        { n: "Sam R.", p: 7210 },
        { n: "Alex T.", p: 6890 },
        { n: "Brooke M.", p: 5440 },
        { n: "Dan W.", p: 4120 },
      ])
    }

    try {
      best = parseInt(localStorage.getItem(BEST_KEY) || "0", 10)
    } catch (e) {}

    // Fetch customer's best score + remaining plays on init
    apiGetMe().then((data) => {
      if (!data) return
      if (typeof data.thisWeekBest === "number") {
        best = data.thisWeekBest
        if ($("start-best")) $("start-best").textContent = best
        if ($("hv-best")) $("hv-best").textContent = best
      } else if (typeof data.best === "number") {
        best = data.best
        if ($("start-best")) $("start-best").textContent = best
        if ($("hv-best")) $("hv-best").textContent = best
      }
      if (typeof data.gamesThisWeek === "number") {
        if ($("start-plays-used")) $("start-plays-used").textContent = data.gamesThisWeek
      }
      if (typeof data.remaining === "number") {
        playsRemaining = data.remaining
        updatePlaysUI()
      }
    })

    function updatePlaysUI() {
      const el = $("start-remaining")
      if (el && playsRemaining !== null) {
        el.textContent = playsRemaining
      }
      const playBtn = $("start-play-btn")
      const noPlays = $("start-no-plays")
      if (playsRemaining === 0) {
        if (playBtn) playBtn.style.display = "none"
        if (noPlays) {
          noPlays.removeAttribute("hidden")
          noPlays.style.display = "flex"
          startResetCountdown()
        }
      } else {
        if (playBtn) playBtn.style.display = ""
        if (noPlays) {
          noPlays.setAttribute("hidden", "")
          noPlays.style.display = "none"
        }
        stopResetCountdown()
      }
    }

    function lockBodyScroll(lock) {
      if (lock) {
        document.body.classList.add("wap-popup-open")
      } else if (!document.querySelector(".wap-popup-backdrop.show")) {
        document.body.classList.remove("wap-popup-open")
      }
    }

    // Observe popup open/close to toggle body scroll lock
    function observePopups() {
      document.querySelectorAll(".wap-popup-backdrop").forEach((popup) => {
        new MutationObserver(() => {
          lockBodyScroll(popup.classList.contains("show"))
        }).observe(popup, { attributes: true, attributeFilter: ["class"] })

        // Close popup when tapping the dim background (but not the sheet itself)
        // The round-popup is exempt — players must press "Next round" to continue.
        if (popup.id === "round-popup") return
        popup.addEventListener("click", (e) => {
          if (e.target === popup) {
            popup.classList.remove("show")
          }
        })
      })
    }

    let countdownInterval = null

    function nextResetTime() {
      // Plays reset Monday 00:00 UTC
      const now = new Date()
      const day = now.getUTCDay()
      const daysUntilMonday = day === 0 ? 1 : 8 - day
      const next = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + daysUntilMonday,
        0, 0, 0, 0
      ))
      return next
    }

    function formatCountdown(ms) {
      if (ms <= 0) return "0d 0h 0m"
      const totalSeconds = Math.floor(ms / 1000)
      const days = Math.floor(totalSeconds / 86400)
      const hours = Math.floor((totalSeconds % 86400) / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      if (days > 0) return `${days}d ${hours}h ${minutes}m`
      if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`
      return `${minutes}m ${seconds}s`
    }

    function startResetCountdown() {
      stopResetCountdown()
      const tick = () => {
        const el = $("reset-countdown")
        if (!el) return
        const ms = nextResetTime().getTime() - Date.now()
        el.textContent = formatCountdown(ms)
        if (ms <= 0) {
          stopResetCountdown()
          // Re-fetch /me to refresh play count
          apiGetMe().then((data) => {
            if (data && typeof data.remaining === "number") {
              playsRemaining = data.remaining
              updatePlaysUI()
            }
          })
        }
      }
      tick()
      countdownInterval = setInterval(tick, 1000)
    }

    function stopResetCountdown() {
      if (countdownInterval) {
        clearInterval(countdownInterval)
        countdownInterval = null
      }
    }

    const $ = (id) => document.getElementById(id)

    if ($("start-best")) $("start-best").textContent = best
    if ($("hv-best")) $("hv-best").textContent = best

    /* ── Build holes ── */
    const holeGrid = $("hole-grid")
    if (holeGrid) {
      for (let i = 0; i < NH; i++) {
        const cell = document.createElement("div")
        cell.className = "wap-hole-cell"
        cell.innerHTML = `<div class="wap-hole-outer">
          <div class="wap-hole-pit"></div>
          <div class="wap-hole-clip">
            <img class="wap-can-img" data-i="${i}" src="" alt="" draggable="false"/>
          </div>
        </div>`
        const img = cell.querySelector(".wap-can-img")
        img.addEventListener("pointerdown", (e) => {
          e.preventDefault()
          tapHole(i)
        })
        holeGrid.appendChild(cell)
        canEls.push(img)
      }
    }

    /* ── Navigation ── */
    function goPage(id) {
      root.querySelectorAll(".wap-page").forEach((p) => p.classList.remove("active"))
      const page = $(id)
      if (page) page.classList.add("active")
    }

    /* ── Leaderboard ── */
    function renderLeaderboard(highlightScore, apiData) {
      // Prefer API data (normalised shape: { top: [{ name, score, rank, isYou }], resetsAt, me })
      let rows = []
      let resetText = ""

      if (apiData && Array.isArray(apiData.top)) {
        rows = apiData.top.map((r) => ({ n: r.name, p: r.score, isYou: r.isYou }))
        if (apiData.resetsAt) {
          const dom = Math.max(0, Math.ceil((new Date(apiData.resetsAt) - Date.now()) / 86400000))
          resetText = `Resets in ${dom} day${dom !== 1 ? "s" : ""}`
        }
      } else {
        // Fallback to local
        rows = getLocalLeaderboard().map((e) => ({ n: e.n, p: e.p }))
        const dom = (8 - new Date().getDay()) % 7 || 7
        resetText = `Resets in ${dom} day${dom !== 1 ? "s" : ""}`
      }

      if ($("lb-meta")) $("lb-meta").textContent = resetText

      const list = $("lb-list")
      if (!list) return
      list.innerHTML = ""
      rows.forEach((entry, i) => {
        const isYou =
          entry.isYou ||
          (highlightScore !== undefined &&
            entry.p === highlightScore &&
            i === rows.findIndex((x) => x.p === highlightScore))
        const row = document.createElement("div")
        row.className = "wap-lb-row" + (isYou ? " you" : "")
        const rk = i === 0 ? "g1" : i === 1 ? "g2" : i === 2 ? "g3" : ""
        row.innerHTML = `<span class="wap-lb-rank ${rk}">${i === 0 ? "🥇" : i + 1}</span>
          <span class="wap-lb-name">${entry.n}${isYou ? '<span class="wap-lb-you">(you)</span>' : ""}</span>
          <span class="wap-lb-pts${i < 3 ? " top" : ""}">${entry.p.toLocaleString()}</span>`
        list.appendChild(row)
      })
    }

    async function openLeaderboard(highlightCurrent) {
      // Show cached data immediately so the page isn't blank
      renderLeaderboard(highlightCurrent ? totalScore : undefined, cachedLeaderboard)
      const backBtn = $("lb-back-btn")
      if (backBtn)
        backBtn.onclick = () => goPage(highlightCurrent ? "pg-end" : "pg-start")
      goPage("pg-lb")

      // Then fetch fresh data and re-render
      const data = await apiGetLeaderboard()
      if (data) renderLeaderboard(highlightCurrent ? totalScore : undefined, data)
    }

    /* ── Game helpers ── */
    const rcfg = () => ROUNDS[currentRound]
    const elapsed = () => rcfg().secs - timeLeft
    const tierIdx = () => {
      const e = elapsed()
      return e < 8 ? 0 : e < 16 ? 1 : e < 23 ? 2 : 3
    }
    const spawnDly = () => rcfg().spawn[tierIdx()]
    const canLife = () => rcfg().life[tierIdx()]
    const emptyH = () =>
      Array.from({ length: NH }, (_, i) => i).filter((i) => !holeState[i])

    function pickCan() {
      // Block-listed customers only ever see danger cans
      if (config.dangerOnly) return DANGER_CAN

      const cfg = rcfg()
      // Winner-listed customers always get gold + normal cans, never danger
      if (config.winnersOnly) {
        if (goldSpawned < cfg.goldCount && Math.random() < 0.06) {
          goldSpawned++
          return GOLD_CAN
        }
        if (!NORMAL_CANS.length) return GOLD_CAN
        return NORMAL_CANS[Math.floor(Math.random() * NORMAL_CANS.length)]
      }

      if (goldSpawned < cfg.goldCount && Math.random() < 0.06) {
        goldSpawned++
        return GOLD_CAN
      }
      if (Math.random() < cfg.dPct) return DANGER_CAN
      if (!NORMAL_CANS.length) return DANGER_CAN
      return NORMAL_CANS[Math.floor(Math.random() * NORMAL_CANS.length)]
    }

    function triggerStreakBonus() {
      if (streakBonusTriggered) return
      streakBonusTriggered = true
      bankedBonus = 3
      showBenchmark("🔥 10 STREAK!", "+3s banked for next round", "#1a50b8")
    }

    /* ── Spawn / retract ── */
    function popUp(idx, can) {
      if (holeState[idx]) return
      const img = canEls[idx]
      img.src = can.image
      img.className =
        "wap-can-img" + (can.type === "d" ? " danger" : can.type === "g" ? " gold" : "")
      setTimeout(
        () =>
          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              if (holeState[idx]) img.classList.add("up")
            })
          ),
        20 + Math.random() * 40
      )
      const tid = setTimeout(() => {
        const st = holeState[idx]
        if (st && st.can === can && running) {
          if (can.type === "n") {
            allMisses++
            roundMisses++
            streak = 0
            combo = 1
            hideCombo()
            doFlash("danger")
          }
          retract(idx)
        }
      }, canLife())
      holeState[idx] = { can, tid }
    }

    function retract(idx) {
      const wasSmashed = canEls[idx].classList.contains("smash")
      canEls[idx].classList.remove("up", "danger", "gold", "smash")
      if (wasSmashed) {
        // Smashed cans fly off-screen — free the hole immediately so spawns aren't blocked
        holeState[idx] = null
      } else {
        // Natural retract (slide-down) — short cool-down so the new can isn't on top
        holeState[idx] = { retracting: true }
        setTimeout(() => {
          if (holeState[idx] && holeState[idx].retracting) {
            holeState[idx] = null
          }
        }, 120)
      }
    }

    /* ── Tap ── */
    function tapHole(idx) {
      const st = holeState[idx]
      if (!st || !st.can || st.retracting || st.smashing || !running) return
      clearTimeout(st.tid)
      const { can } = st
      // Mark hole as smashing so it stays "occupied" through the animation
      holeState[idx] = { smashing: true }
      const img = canEls[idx]
      const ir = img.getBoundingClientRect()
      const fr = $("felt").getBoundingClientRect()
      const cx = ir.left - fr.left + ir.width / 2
      const cy = ir.top - fr.top + ir.height / 2
      img.classList.add("smash")
      setTimeout(() => retract(idx), 280)

      let pts, cls, txt
      if (can.type === "g") {
        allHits++
        roundHits++
        pts = 20 * (combo || 1)
        cls = "hit"
        txt = `+${pts} x2!`
        sparks(cx, cy, "#f59e0b", 12)
        doFlash("hit")
        showBenchmark("+" + pts, "DOUBLE POINTS!", "#f59e0b")
      } else if (can.type === "n") {
        allHits++
        roundHits++
        streak++
        if (streak > bestStreak) bestStreak = streak
        combo = streak >= 10 ? 4 : streak >= 6 ? 3 : streak >= 3 ? 2 : 1
        if (combo > peakCombo) peakCombo = combo
        pts = 10 * combo
        cls = "hit"
        txt = `+${pts}${combo > 1 ? " x" + combo : ""}`
        sparks(cx, cy, "#2160CD", 9)
        doFlash("hit")
        showCombo()
        if (streak === 10) triggerStreakBonus()
        else if (streak === 3) showBenchmark("3 STREAK", "x2 Combo!", "#2160CD")
        else if (streak === 6) showBenchmark("6 STREAK", "x3 Combo!", "#7c3aed")
      } else {
        allMisses++
        roundMisses++
        streak = 0
        combo = 1
        pts = -20
        cls = "danger"
        txt = "-20 -3s"
        timeLeft = Math.max(1, timeLeft - 3)
        if ($("hv-time")) $("hv-time").textContent = timeLeft
        sparks(cx, cy, "#e63946", 8)
        doFlash("danger")
        hideCombo()
      }

      roundScore = Math.max(0, roundScore + pts)
      totalScore = Math.max(0, totalScore + pts)
      if ($("hv-score")) $("hv-score").textContent = roundScore.toLocaleString()
      if ($("hv-total")) $("hv-total").textContent = totalScore.toLocaleString()

      const pop = document.createElement("div")
      pop.className = "wap-score-pop " + cls
      pop.textContent = txt
      pop.style.cssText = `left:${cx - 26}px;top:${cy - 12}px;`
      $("felt").appendChild(pop)
      setTimeout(() => pop.remove(), 850)
      if (navigator.vibrate) navigator.vibrate(can.type === "d" ? [18, 10, 18] : [12])
    }

    /* ── Benchmark popup ── */
    function showBenchmark(label, sub, color) {
      const felt = $("felt")
      if (!felt) return
      // Remove any existing benchmark popup so only one shows at a time
      const existing = felt.querySelector(".wap-bench-pop")
      if (existing) existing.remove()

      const el = document.createElement("div")
      el.className = "wap-bench-pop"
      el.style.background = color
      el.innerHTML = `<div class="wap-bp-main">${label}</div><div class="wap-bp-sub">${sub}</div>`
      felt.appendChild(el)

      // Force layout, then trigger the show animation
      requestAnimationFrame(() => {
        el.classList.add("show")
      })
      setTimeout(() => {
        el.classList.remove("show")
        el.classList.add("hide")
        setTimeout(() => el.remove(), 300)
      }, 900)
    }

    function showCombo() {
      if (combo < 2) {
        hideCombo()
        return
      }
      const labels = ["", "", "Double!", "Triple!", "Quad!"]
      if ($("combo-txt")) {
        $("combo-txt").textContent = `x${combo} ${labels[combo] || "Mega!"}`
        $("combo-txt").style.opacity = "1"
      }
    }

    function hideCombo() {
      if ($("combo-txt")) $("combo-txt").style.opacity = "0"
    }

    function doFlash(cls) {
      const f = $("screen-flash")
      if (!f) return
      f.className = cls
      void f.offsetWidth
      f.className = cls
    }

    function sparks(cx, cy, col, n) {
      const felt = $("felt")
      if (!felt) return
      for (let i = 0; i < n; i++) {
        const s = document.createElement("div")
        s.className = "wap-spark-dot"
        const sz = 3 + Math.random() * 5
        s.style.cssText = `width:${sz}px;height:${sz}px;background:${col};left:${cx}px;top:${cy}px;position:absolute;`
        felt.appendChild(s)
        const a = Math.random() * Math.PI * 2
        const d = 16 + Math.random() * 50
        const dur = 280 + Math.random() * 200
        s.animate(
          [
            { transform: `translate(-50%,-50%) scale(1)`, opacity: 1 },
            {
              transform: `translate(calc(-50% + ${Math.cos(a) * d}px),calc(-50% + ${Math.sin(a) * d}px)) scale(0)`,
              opacity: 0,
            },
          ],
          { duration: dur, easing: "cubic-bezier(0,0,.2,1)", fill: "forwards" }
        )
        setTimeout(() => s.remove(), dur + 60)
      }
    }

    /* ── Spawn loop ── */
    function scheduleSpawn() {
      if (!running) return
      const empty = emptyH()
      if (empty.length) {
        const extra = currentRound === 2 && Math.random() < 0.25 && empty.length > 2
        for (let c = 0; c < (extra ? 2 : 1); c++) {
          const rem = emptyH()
          if (!rem.length) break
          popUp(rem[Math.floor(Math.random() * rem.length)], pickCan())
        }
      }
      spawnId = setTimeout(scheduleSpawn, spawnDly())
    }

    /* ── Round UI ── */
    function updateRoundUI() {
      if ($("rb-val"))
        $("rb-val").textContent = `${currentRound + 1} of ${TOTAL_ROUNDS}`
      for (let i = 0; i < TOTAL_ROUNDS; i++) {
        const dot = $("rd" + i)
        if (dot)
          dot.className =
            "wap-rb-dot" + (i < currentRound ? " done" : i === currentRound ? " active" : "")
      }
    }

    /* ── Start round ── */
    function startRound() {
      roundScore = 0
      roundHits = 0
      roundMisses = 0
      timeLeft = rcfg().secs + bankedBonus
      bankedBonus = 0
      streakBonusTriggered = false
      goldSpawned = 0
      running = true
      for (let i = 0; i < NH; i++) {
        if (holeState[i]) {
          clearTimeout(holeState[i].tid)
          retract(i)
        }
      }
      if ($("hv-score")) $("hv-score").textContent = "0"
      if ($("hv-time")) {
        $("hv-time").textContent = timeLeft
        $("hv-time").classList.remove("urgent")
      }
      if ($("timer-fill")) $("timer-fill").style.width = "100%"
      hideCombo()
      updateRoundUI()
      clearInterval(tickId)
      tickId = setInterval(() => {
        timeLeft--
        if ($("hv-time")) $("hv-time").textContent = timeLeft
        if (timeLeft <= 8 && $("hv-time")) $("hv-time").classList.add("urgent")
        if ($("timer-fill"))
          $("timer-fill").style.width = (timeLeft / rcfg().secs) * 100 + "%"
        if (timeLeft <= 0) endRound()
      }, 1000)
      scheduleSpawn()
    }

    /* ── End round ── */
    function endRound() {
      running = false
      clearInterval(tickId)
      clearTimeout(spawnId)
      for (let i = 0; i < NH; i++) {
        if (holeState[i]) {
          clearTimeout(holeState[i].tid)
          retract(i)
        }
      }
      roundScores[currentRound] = roundScore

      // Save progress after every round (so it isn't lost if the player leaves)
      apiSaveProgress({
        roundIndex: currentRound,
        roundScore: roundScore,
        roundHits: roundHits,
        roundMisses: roundMisses,
        totalScore: totalScore,
        hits: allHits,
        misses: allMisses,
        peakCombo: peakCombo,
        bestStreak: bestStreak,
        roundScores: roundScores.slice(),
      })

      if (currentRound < TOTAL_ROUNDS - 1) {
        const cfg = rcfg()
        if ($("rp-tier")) $("rp-tier").textContent = cfg.title
        if ($("rp-body")) $("rp-body").textContent = cfg.msg
        if ($("rp-card-title")) $("rp-card-title").textContent = roundScore.toLocaleString()
        if ($("rp-card-sub"))
          $("rp-card-sub").textContent = `${roundHits} hits · ${roundMisses} misses`
        if ($("rp-hint")) $("rp-hint").textContent = cfg.hint
        if ($("rp-btn")) $("rp-btn").textContent = cfg.btnTxt
        const popup = document.querySelector("#round-popup")
        if (popup) popup.classList.add("show")
      } else {
        endGame()
      }
    }

    function nextRound() {
      const popup = document.querySelector("#round-popup")
      if (popup) popup.classList.remove("show")
      currentRound++
      startRound()
    }

    /* ── Full game start ── */
    async function startGame() {
      // Ask the app for a sessionToken + play allowance
      const startResp = await apiStartGame()
      if (startResp && startResp.error === "no_plays") {
        alert(startResp.message || "You've used all your plays this week. Come back next week!")
        return
      }
      if (startResp && startResp.error === "not_logged_in") {
        window.location.href = "/account/login"
        return
      }

      // Optimistically update chips — play count consumed
      if (startResp && typeof startResp.remaining === "number") {
        playsRemaining = startResp.remaining
        if ($("start-remaining")) $("start-remaining").textContent = startResp.remaining
      } else if (typeof playsRemaining === "number" && playsRemaining > 0) {
        playsRemaining = playsRemaining - 1
        if ($("start-remaining")) $("start-remaining").textContent = playsRemaining
      }
      const playsUsedEl = $("start-plays-used")
      if (playsUsedEl) {
        const current = parseInt(playsUsedEl.textContent, 10) || 0
        playsUsedEl.textContent = current + 1
      }

      gameStartedAt = Date.now()
      scoreSubmitted = false
      currentRound = 0
      totalScore = 0
      roundScores = [0, 0, 0]
      allHits = 0
      allMisses = 0
      streak = 0
      bestStreak = 0
      combo = 1
      peakCombo = 1
      bankedBonus = 0
      if ($("hv-total")) $("hv-total").textContent = "0"
      const popup = document.querySelector("#round-popup")
      if (popup) popup.classList.remove("show")
      goPage("pg-game")
      startRound()
    }

    /* ── End game ── */
    async function endGame() {
      const tot = allHits + allMisses
      const acc = tot ? Math.round((allHits / tot) * 100) : 0
      if (totalScore > best) {
        best = totalScore
        try {
          localStorage.setItem(BEST_KEY, best)
        } catch (e) {}
      }
      if ($("start-best")) $("start-best").textContent = best
      if ($("end-rank")) $("end-rank").textContent = "GAME COMPLETE"
      if ($("end-score")) $("end-score").textContent = totalScore.toLocaleString()
      if ($("end-sub"))
        $("end-sub").textContent = `${allHits} hits  ${allMisses} misses  streak ${bestStreak}`
      if ($("stat-acc")) $("stat-acc").textContent = acc + "%"
      if ($("stat-mx")) $("stat-mx").textContent = "x" + peakCombo
      if ($("stat-str")) $("stat-str").textContent = bestStreak
      const maxR = Math.max(...roundScores, 1)
      roundScores.forEach((s, i) => {
        if ($("rs-v" + i)) $("rs-v" + i).textContent = s.toLocaleString()
        if ($("rs-b" + i)) $("rs-b" + i).style.width = (s / maxR) * 100 + "%"
      })
      goPage("pg-end")

      // Pre-populate the popup form with the user's saved name, or the customer's Shopify name
      const fpNameInput = $("fp-name-input")
      let savedName = ""
      try {
        savedName = localStorage.getItem("wap_display_name") || ""
      } catch (e) {}
      const prefill = savedName || (config && config.displayName) || ""
      if (fpNameInput && prefill) fpNameInput.value = prefill

      // Show popup with "Submitting..." state
      if ($("fp-tier")) $("fp-tier").textContent = "SAVING SCORE..."
      if ($("fp-title")) $("fp-title").textContent = `Total: ${totalScore.toLocaleString()}`
      if ($("fp-body")) $("fp-body").textContent = `You scored ${totalScore.toLocaleString()} across 3 rounds.`
      if ($("fp-card-title")) $("fp-card-title").textContent = totalScore.toLocaleString()
      if ($("fp-card-sub"))
        $("fp-card-sub").textContent = `${allHits} hits · ${allMisses} misses · streak ${bestStreak}`

      const submitBtn = $("fp-submit-btn")
      const closeBtn = $("fp-close-btn")
      const nameForm = $("fp-name-form")

      if (submitBtn) {
        submitBtn.textContent = "Update name"
        submitBtn.disabled = false
        submitBtn.style.display = ""
      }
      if (nameForm) nameForm.style.display = ""
      if (closeBtn) {
        closeBtn.style.display = "none"
        closeBtn.hidden = true
      }

      setTimeout(() => {
        const popup = document.querySelector("#final-popup")
        if (popup) popup.classList.add("show")
      }, 400)

      // Auto-submit the score immediately — so it's saved even if the player closes the page
      const autoName = prefill || ""
      const autoResult = await apiSubmitScore({
        score: totalScore,
        hits: allHits,
        misses: allMisses,
        peakCombo: peakCombo,
        bestStreak: bestStreak,
        roundScores: roundScores,
        displayName: autoName,
      })

      console.log("Whack-A-Pouch auto-submit response:", autoResult)

      const alreadySubmitted =
        autoResult &&
        (autoResult._status === 409 ||
          autoResult.error === "duplicate" ||
          autoResult.error === "already_submitted")

      if (autoResult && autoResult.success) {
        scoreSubmitted = true
        clearProgress()
        const rank = autoResult.rank
        const isHigh = rank === 1
        if (typeof autoResult.thisWeekBest === "number" && autoResult.thisWeekBest > best) {
          best = autoResult.thisWeekBest
          if ($("start-best")) $("start-best").textContent = best
          if ($("hv-best")) $("hv-best").textContent = best
        }
        const fpTier = isHigh ? "NEW HIGH SCORE! 🏆" : "SCORE SUBMITTED"
        const fpHint = rank
          ? `You're ranked #${rank} this week`
          : "Keep playing to climb the leaderboard"
        if ($("fp-tier")) $("fp-tier").textContent = fpTier
        if ($("fp-hint")) $("fp-hint").textContent = fpHint
        if (submitBtn) submitBtn.textContent = "Update name"
      } else if (alreadySubmitted) {
        // 409 — already submitted with this token, treat as success
        scoreSubmitted = true
        clearProgress()
        if ($("fp-tier")) $("fp-tier").textContent = "SCORE SUBMITTED"
        if (submitBtn) submitBtn.textContent = "Update name"
      } else {
        // Surface the actual error message so we can debug
        const errMsg = autoResult && (autoResult.message || autoResult.error)
          ? `${autoResult._status || ""} ${autoResult.message || autoResult.error}`.trim()
          : "Couldn't reach the server"
        if ($("fp-tier")) $("fp-tier").textContent = "SAVE FAILED"
        if ($("fp-hint")) $("fp-hint").textContent = errMsg
        if (submitBtn) submitBtn.textContent = "Retry submit"
      }
    }

    async function submitScoreFromPopup() {
      const fpNameInput = $("fp-name-input")
      const submitBtn = $("fp-submit-btn")
      const closeBtn = $("fp-close-btn")
      const nameForm = $("fp-name-form")

      const typed = (fpNameInput && fpNameInput.value.trim()) || ""
      const fallback = (config && config.displayName && config.displayName.trim()) || ""
      const enteredName = typed || fallback

      // Require a name — don't allow empty submission
      if (!enteredName) {
        if (fpNameInput) {
          fpNameInput.focus()
          fpNameInput.style.borderColor = "var(--wap-danger, #E63946)"
          const oldPlaceholder = fpNameInput.placeholder
          fpNameInput.placeholder = "Please enter a name"
          setTimeout(() => {
            fpNameInput.style.borderColor = ""
            fpNameInput.placeholder = oldPlaceholder
          }, 2500)
        }
        return
      }

      // Persist the chosen name locally so it pre-fills next time
      try {
        localStorage.setItem("wap_display_name", enteredName)
      } catch (e) {}

      if (submitBtn) {
        submitBtn.textContent = scoreSubmitted ? "Updating..." : "Submitting..."
        submitBtn.disabled = true
      }

      let result = null
      if (scoreSubmitted) {
        // Score already saved — just update the name (no play count impact)
        result = await apiUpdateName(enteredName)
      } else {
        // Auto-submit failed earlier — try /score again
        result = await apiSubmitScore({
          score: totalScore,
          hits: allHits,
          misses: allMisses,
          peakCombo: peakCombo,
          bestStreak: bestStreak,
          roundScores: roundScores,
          displayName: enteredName,
        })
        if (result && result.success) {
          scoreSubmitted = true
        } else if (
          result &&
          (result._status === 409 ||
            result.error === "duplicate" ||
            result.error === "already_submitted")
        ) {
          // Already submitted — switch to updating the name instead
          scoreSubmitted = true
          result = await apiUpdateName(enteredName)
        }
      }

      console.log("Whack-A-Pouch manual submit response:", result)

      if (!result || !result.success) {
        // Failed — re-enable the button so they can retry
        const errMsg = result && (result.message || result.error)
          ? `${result._status || ""} ${result.message || result.error}`.trim()
          : "Couldn't reach the server"
        if ($("fp-hint")) $("fp-hint").textContent = errMsg
        if (submitBtn) {
          submitBtn.textContent = scoreSubmitted ? "Update name" : "Retry submit"
          submitBtn.disabled = false
        }
        return
      }

      // For /score result, capture rank + best
      if (typeof result.rank === "number") {
        const isHigh = result.rank === 1
        const fpTier = isHigh ? "NEW HIGH SCORE! 🏆" : "SCORE SUBMITTED"
        const fpHint = `You're ranked #${result.rank} this week`
        if ($("fp-tier")) $("fp-tier").textContent = fpTier
        if ($("fp-hint")) $("fp-hint").textContent = fpHint
        const newBest =
          typeof result.thisWeekBest === "number"
            ? result.thisWeekBest
            : result.personalBest
        if (typeof newBest === "number" && newBest > best) {
          best = newBest
          if ($("start-best")) $("start-best").textContent = best
          if ($("hv-best")) $("hv-best").textContent = best
        }
      }

      // Hide form, show view-leaderboard button
      if (nameForm) nameForm.style.display = "none"
      if (submitBtn) submitBtn.style.display = "none"
      if (closeBtn) {
        closeBtn.style.display = ""
        closeBtn.removeAttribute("hidden")
        closeBtn.textContent = "View leaderboard"
        closeBtn.setAttribute("data-wap-action", "close-final-lb")
      }
    }

    /* ── Share ── */
    function shareScore() {
      const text = `I scored ${totalScore.toLocaleString()} on Whack-A-Pouch at ${window.location.origin} — can you beat me?`
      const url = window.location.href
      if (navigator.share) {
        navigator.share({ title: "Whack-A-Pouch", text, url }).catch(() => {})
      } else {
        navigator.clipboard
          .writeText(text + " " + url)
          .then(() => {
            const btn = $("btn-share")
            if (btn) {
              btn.textContent = "Copied!"
              setTimeout(() => (btn.textContent = "Share score"), 1600)
            }
          })
          .catch(() => {})
      }
    }

    /* ── Bind events (delegated so it catches elements outside root, e.g. popups) ── */
    document.addEventListener("click", (e) => {
      const el = e.target.closest("[data-wap-action]")
      if (!el) return
      const action = el.getAttribute("data-wap-action")
      if (action === "start") startGame()
      else if (action === "next-round") nextRound()
      else if (action === "submit-score") submitScoreFromPopup()
      else if (action === "open-lb") openLeaderboard(false)
      else if (action === "open-lb-form") openLeaderboard(true)
      else if (action === "main-menu") goPage("pg-start")
      else if (action === "share") shareScore()
      else if (action === "close-final") {
        const popup = document.querySelector("#final-popup")
        if (popup) popup.classList.remove("show")
      } else if (action === "close-final-lb") {
        const popup = document.querySelector("#final-popup")
        if (popup) popup.classList.remove("show")
        openLeaderboard(true)
      }
    })

    observePopups()

    document.addEventListener("contextmenu", (e) => {
      if (root.contains(e.target)) e.preventDefault()
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()
